import { Box, Chip, CircularProgress } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const loadMoreMessage = defineMessage({
  id: 'notifications.feed.loadMore',
  defaultMessage: 'Cargar más',
});

export type NotificationFeedLoadMoreProps = {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
};

/**
 * Footer control to fetch the next page of feed items.
 */
export function NotificationFeedLoadMore({
  hasMore,
  loading,
  onLoadMore,
}: NotificationFeedLoadMoreProps) {
  const $t = useIntl().formatMessage;

  if (!hasMore && !loading) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, px: 2 }}>
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <Chip
          label={$t(loadMoreMessage)}
          variant="outlined"
          size="small"
          clickable
          onClick={onLoadMore}
        />
      )}
    </Box>
  );
}
